// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Back',
    create: 'Create',
    new: 'Create New Claim',
    role: 'Claim',
    delete: 'Delete',
    name: 'Name',
    save: 'Save',
    confirm_delete: 'Confirm Deletion'
}
